export { Accidents as default } from '@/screens/accidents/Accidents'
